<mat-toolbar #navToolbar
             color="primary"
             class="nav-toolbar"
             [class.nav-toolbar-over]="sidenav.mode == 'over'">
    <a *ngIf="sidenav.mode == 'over'"
       (click)="toggleSidebar()"
       mat-icon-button>
        <mat-icon>menu</mat-icon>
    </a>
    <a [routerLink]="[uiPathLogoRoute]"
       class="navbar-brand pull-left">
        <ui-logo [width]="120"
                 [height]="55">
        </ui-logo>
    </a>
    <div class="toolbar-navigation">
        <div class="title-container"
             [style.marginLeft.px]="sidebarWidth">
            <span *ngIf="showAccessDeniedTitle"
                  class="nav-title">
                {{ deniedPage?.translationKey | translate }}
            </span>
            <ng-container *ngIf="!showAccessDeniedTitle">
                <ui-top-navigation></ui-top-navigation>
            </ng-container>
        </div>
        <div class="action-container">
            <ui-folder-picker *ngIf="!isHost"></ui-folder-picker>
            <a [href]="helpUrl"
               [attr.target]="'_blank'"
               [matTooltip]="'main_help_tooltip' | translate"
               mat-icon-button>
                <mat-icon>help</mat-icon>
            </a>
            <ng-container *ngIf="currentUser$ | async as currentUser">
                <ui-alerts *ngIf="!isHost && hasFolder"
                           [seeAllPlaceholder]="'alerts_component_action_see_all' | translate"
                           [noAlertsPlaceholder]="'alerts_component_no_alerts' | translate"
                           [settingsTooltip]="'notifications_settings_open_tooltip' | translate"
                           [title]="'page_alerts' | translate"
                           [uiAuthorize]="'Alerts.View'"
                           (openSettings)="onOpenNotificationSettings()">
                </ui-alerts>
                <button [matMenuTriggerFor]="userMenu"
                        [title]="'main_user_tooltip' | translate"
                        mat-mini-fab
                        class="mat-elevation-z0 user-menu-button"
                        data-cy="setting-menu-trigger"
                        type="button">
                    {{getInitials(currentUser)}}
                </button>
                <mat-menu #userMenu="matMenu"
                          [overlapTrigger]="false">
                    <ng-container *ngFor="let item of menuItems">
                        <ng-container [ngSwitch]="item.type">
                            <ng-container *ngSwitchCase="'userProfile'">
                                <a [routerLink]="isHost ?
                                                    ['/host/profile'] :
                                                    ['/profile']"
                                   mat-menu-item>
                                    <mat-icon>account_circle</mat-icon>
                                    {{ 'navbar_menu_my_profile' | translate }}
                                </a>
                            </ng-container>
                            <ng-container *ngSwitchCase="'page'">
                                <a *ngLet="item.page as page"
                                   [routerLink]="[page.routerLink]"
                                   [routerLinkActive]="['active']"
                                   [uiAuthorize]="page.permission"
                                   mat-menu-item
                                   class="dropdown-item">
                                    <span [class.ui-svg-container]="!!page.svgIcon">
                                        <mat-icon *ngIf="page.svgIcon"
                                                  [svgIcon]="page.svgIcon"
                                                  mat-list-icon></mat-icon>
                                        <mat-icon *ngIf="!page.svgIcon"
                                                  mat-list-icon>{{page.icon}}</mat-icon>
                                    </span>
                                    <span>
                                        {{ page.translationKey | translate }}
                                    </span>
                                </a>
                            </ng-container>
                            <ng-container *ngSwitchCase="'logout'">
                                <a [uiClickTrack]="'Action: Logout'"
                                   (click)="logout()"
                                   (keydown.enter)="logout()"
                                   mat-menu-item
                                   data-cy="logout-btn">
                                    <mat-icon mat-list-icon>exit_to_app</mat-icon>
                                    {{ 'main_logout' | translate }}
                                </a>
                            </ng-container>
                        </ng-container>
                    </ng-container>
                </mat-menu>
            </ng-container>
        </div>
    </div>
</mat-toolbar>
<mat-sidenav-container #sidenavContainer>
    <mat-sidenav #sidenav
                 [disableClose]="sidenav.mode === 'side'"
                 [opened]="sideNavOpened">
        <div class="side-content-container layout-column">
            <ui-sidebar-navigation (widthChange)="updateSidebarWidth($event)"></ui-sidebar-navigation>

            <span class="flex"></span>
            <div *ngLet="authConfig$ | async as authConfig"
                 class="side-info">
                <ui-language-selector *ngIf="authConfig.application.isLocalizationEnabled"
                                      [languages$]="languages$"
                                      (change)="changeLanguage($event)">
                </ui-language-selector>
                <div>
                    © UiPath {{ authConfig.serverSettings.year }}
                </div>
                <div [title]="'global_build_date' | translate: authConfig.serverSettings.build"
                     matTooltipPosition="right">
                    Orchestrator {{ customTitle }}
                    <span class="nowrap">{{ authConfig.serverSettings.build.version }}</span>
                </div>
                <ui-license-status [license]="license$ | async"
                                   mode="condensed">
                </ui-license-status>
            </div>
        </div>
    </mat-sidenav>
    <div class="ui-mat-content">
        <div class="layout-row layout-align-v-center layout-align-h-start">
            <div role="main"
                 class="flex-100 main-content">
                <ui-breadcrumbs *ngIf="!isHost">
                </ui-breadcrumbs>
                <router-outlet></router-outlet>
            </div>
        </div>
    </div>
</mat-sidenav-container>
<span defaultOverlayTarget></span>
